import { createBrowserRouter } from "react-router-dom";
import Cookies from "js-cookie";
import Layout from "../layouts/Layout";
import MainDashboard from "../pages/main/MainDashboard";
import Categories from "../pages/categories/Categories";
import Orders from "../pages/order/Orders";
import OrderDetails from "../pages/order/OrderDetails";
import Transactions from "../pages/transactions/Transactions";
import Product from "../pages/product/Product";
import Reports from "../pages/report/Reports";
import Reviews from "../pages/reviews/Reviews";
import Settings from "../pages/settings/Settings";
import Users from "../pages/users/Users";
import Shipping from "../pages/shipping/Shipping";
import AddProduct from "../pages/product/AddProduct";
import EditProduct from "../pages/product/EditProduct";
import Login from "../pages/login/Login";
import ResetPassword from "../pages/login/ResetPassword";
import Verify2FA from "../pages/login/Verify2FA";

const ProtectedRoute = ({ element }) => {
  const authToken = Cookies.get("authToken");
  if (!authToken) {
    window.location.href = "/login";
    return null;
  }
  return element;
};

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/verify-2fa",
    element: <Verify2FA />,
  },
  {
    path: "/",
    element: <ProtectedRoute element={<Layout />} />,
    children: [
      {
        path: "/",
        element: <MainDashboard />,
      },
      {
        path: "/categories",
        element: <Categories />,
      },
      {
        path: "/orders",
        element: <Orders />,
      },
      {
        path: "/orders/:orderId",
        element: <OrderDetails />,
      },
      {
        path: "/transactions",
        element: <Transactions />,
      },
      {
        path: "/product",
        element: <Product />,
      },
      {
        path: "/product/add",
        element: <AddProduct />,
      },
      {
        path: "/product/edit/:productId",
        element: <EditProduct />,
      },
      {
        path: "/reports",
        element: <Reports />,
      },
      {
        path: "/reviews",
        element: <Reviews />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/users",
        element: <Users />,
      },
      {
        path: "/shipping",
        element: <Shipping />,
      },
    ],
  },
]);
